'use strict';

var gmaps = require('../gmaps-api');

var $mapsContainer = $('.locations-map');
var zoomLevel = document.documentElement.clientWidth < 480 ? 9 : 10;
var mapType = $mapsContainer.data('maptype');
var isCityMap = mapType === 'city';
var isSpainMap = mapType === 'spain';
var svgVersion = window.svgVersion || '/build/svg/dist.svg';

window.initMap = function () {
  if ( $mapsContainer.length ) {
    gmaps.getMapsAPI()
      // Loaded maps
      .then(loadMaps)
      // Error loading maps
      .catch(function mapsError(e) {
        console.error(e);
      });
  }
}

if (!isCityMap) {
  initMap();
}


// Load the map with markers
function loadMaps(gmaps) {
	var markerData = $mapsContainer.data('markers');
	var markers = [];

	// Config options
	var mapConfig = {
		zoom: isCityMap? 16 : 8,
		scrollwheel: false,
		gestureHandling: 'cooperative',
		mapTypeControl: false,
		streetViewControl: false,
		center: new gmaps.LatLng(52.100556, 5.645833)
	};
	var icon = {
		anchor: new gmaps.Point(19, 58),
		scaledSize: new gmaps.Size(60,64),
		url: '/assets/images/misc/marker.png'
	};
	var markerOptions = {
		animation: gmaps.Animation.DROP,
		icon: icon,
		map: map
	};

	// Map feature instances
	var bounds = new gmaps.LatLngBounds();
	var map = new gmaps.Map($mapsContainer[0], mapConfig);
	var infoWindow = new gmaps.InfoWindow();

	// Add markers
	markerData.forEach(function (marker, i) {
		var position = {
			lat: marker.lat,
			lng: marker.lng
		};

		if ( position.lat === null && position.lng === null ) {
			return;
		}

		// Add marker to map
		markers[i] = new gmaps.Marker({
			position: position,
			icon: icon,
			map: map,
			markerName: marker.name,
			markerUrl: marker.url || false,
			address1: marker.address1 || false,
			address2: marker.address2 || false,
			description: marker.description || false
		});

		// Open infoWindow and set content on click on marker
		markers[i].addListener('click', function () {
			infoWindow.setOptions({
				content: getInfoWindowContent({
					name: this.markerName,
					address1: this.address1,
					address2: this.address2,
					description: this.description,
					url: this.markerUrl
				}),
				position: this.position,
				pixelOffset: new gmaps.Size(0, -70)
			});
			infoWindow.open(map);
		});

		// Add marker to bounds
		bounds.extend(position);
	});

	// Fit map to marker bounds and center position
	map.setCenter(bounds.getCenter());
	if (markers.length > 1) {
		map.fitBounds(bounds);
	}

	if (!isSpainMap) {
    initGeolocation(map, gmaps);
    initGeocoding(map, gmaps);
	}
}

function getInfoWindowContent(opts) {
	var html = '';
	var directionsUrl;

	html += isCityMap? '<div class="locations-map-info locations-map-info--location">' : '<div class="locations-map-info">';
	html += 	'<h2>' + opts.name + '</h2>';
	if (isCityMap) {
		directionsUrl = encodeURIComponent(opts.address1 + ',' + opts.address2 + ',Nederland');
		html += '<p class="address">' + opts.address1 + ', ' + opts.address2 + '</p>';
		html += opts.description.length > 0? its2017WhyCantFuckingJavascriptDecodeSomeHTML(opts.description) : '';
		html += '<a href="https://www.google.com/maps/dir/current+location/' + directionsUrl + '/" target="_blank">';
		html +=	'Routebeschrijving';
		html +=	getSvg('arrow-right', 8, 8);
		html += '</a>';
	} else if (isSpainMap) {
		html += '<a href="' + opts.url + '">';
		html +=	'Meer informatie';
		html +=	getSvg('arrow-right', 8, 8);
		html += '</a>';
	} else {
		html += '<a href="' + opts.url + '">';
		html +=	getSvg('book', 20, 20);
		html +=	'Bekijk het cursusaanbod';
		html +=	getSvg('arrow-right', 8, 8);
		html += '</a>';
	}
	html += '</div>';

	return decodeURI(html);
};

function getSvg(name, width, height) {
	var html = '';

	html += '<svg width="' + width + '" height="' + height + '">';
	html += 	'<use xlink:href="' + svgVersion + '#' + name + '">';
	html += '</svg>';

	return html;
}

function initGeolocation(map) {
	if ( 'geolocation' in navigator && !isCityMap && !isSpainMap ) {
		navigator.geolocation.getCurrentPosition(function processGeolocation(result) {
			if ( result.coords.latitude && result.coords.latitude ) {
				map.setCenter({
					lat: result.coords.latitude,
					lng: result.coords.longitude
				});
				map.setZoom(zoomLevel);
			}
		});
	}
}

function initGeocoding(map, gmaps) {
	var $searchBar = $('.location-search-bar');
	var $noResults = $searchBar.find('.no-results');
	var geocoder = new gmaps.Geocoder();

	$searchBar.on('submit', function geocodeAddress(e) {
		var $form = $(this);

		e.preventDefault();

		$noResults.empty().addClass('hidden');

		geocoder.geocode({
			address: $searchBar.find('.location-search-input').val(),
			componentRestrictions: {
				country: 'nl'
			}
		}, function processResults (results) {
			// if ( results.length && checkTypes(results[0].types) ) {

			if ( results.length ) { // IvdW: Disabled result type checking for now (24-01-2017)
				map.setCenter({
					lat: results[0].geometry.location.lat(),
					lng: results[0].geometry.location.lng()
				});
				map.setZoom(zoomLevel);
			} else {
				$noResults.text('Geen resultaten gevonden, probeer het nogmaals').removeClass('hidden');
			}
		});
	});
}

// Check if items in the result match the allowed types
function checkTypes(types) {
	var allowedTypes = [
		'sublocality',
		'locality',
		'postal_code',
		'street_address',
		'colloquial_area',
		'administrative_area_level_2'
	];

	return types.some(function functionName(type) {
		return allowedTypes.indexOf(type) !== -1
	});
}

function its2017WhyCantFuckingJavascriptDecodeSomeHTML(html) {
	var ugh = document.createElement("textarea");
	var comeOnnnn;
	ugh.innerHTML = html;
	comeOnnnn = ugh.value;
	return comeOnnnn;
}
